import { createReducer } from '@src/redux/helpers/createReducer';
import { UPDATE_TIN, VALIDATE_TIN } from './constants';

const initialState = {
  trackingNumber: {},
};

export const postRegistrationReducer = createReducer(initialState, {
  [`${UPDATE_TIN}_STARTED`]: (state, action) => {
    return {
      trackingNumber: { ...state },
    };
  },
  [`${UPDATE_TIN}_SUCCESS`]: (state, action) => {
    return {
      ...state,
      trackingNumber: { ...state, ...action.payload },
    };
  },
  [`${VALIDATE_TIN}_STARTED`]: (state, action) => {
    return {
      trackingNumber: {},
    };
  },

  [`${VALIDATE_TIN}_SUCCESS`]: (state, action) => {
    const val = {
      ...state,
      trackingNumber: { ...state, ...action.payload },
    };
    return val;
  },
});
